'use client'

import { useEffect } from 'react'

import { Input, Button, Label, Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from '@fp/ui-kit'

type SaveFilterModalProps = {
  isOpen: boolean
  onCancel: () => void
  onSave: (name: string) => void
  filterName: string
  setFilterName: (name: string) => void
}

export const SaveFilterModal = ({ isOpen, onCancel, onSave, filterName, setFilterName }: SaveFilterModalProps) => {
  useEffect(() => {
    if (!isOpen) setFilterName('')
  }, [isOpen, setFilterName])

  return (
    <Dialog open={isOpen} onOpenChange={onCancel}>
      <DialogContent className='sm:max-w-md'>
        <DialogHeader>
          <DialogTitle>Save your predefined filters</DialogTitle>
        </DialogHeader>

        <div className='space-y-2 py-2'>
          <Label htmlFor='filter-name'>Name your settings</Label>
          <Input
            id='filter-name'
            placeholder='Enter filter name'
            value={filterName}
            onChange={(e) => setFilterName(e.target.value)}
          />
        </div>

        <DialogFooter className='mt-4 flex gap-2'>
          <Button variant='primary' onClick={() => onSave(filterName)} disabled={!filterName.trim()} className='w-full'>
            Save
          </Button>
          <Button variant='outline' onClick={onCancel} className='w-full'>
            Cancel
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  )
}
